function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "_001-heart",
  "data-name": "001-heart",
  d: "M12.545,56.293a.734.734,0,0,1-.367-.1,43.894,43.894,0,0,1-6.033-4.341A24.887,24.887,0,0,1,1.96,47.369,9.459,9.459,0,0,1,0,41.988a7.768,7.768,0,0,1,1.981-5.2,6.5,6.5,0,0,1,4.835-2.192,6.71,6.71,0,0,1,5.728,3.4,6.71,6.71,0,0,1,5.728-3.4,6.532,6.532,0,0,1,4.648,1.978A7.658,7.658,0,0,1,25.09,42a9.643,9.643,0,0,1-2,5.372,25.209,25.209,0,0,1-4.179,4.483,44.046,44.046,0,0,1-6,4.341.735.735,0,0,1-.37.1Z",
  transform: "translate(0 -34.594)"
});

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25.09,
    height: 21.699,
    viewBox: "0 0 25.09 21.699",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Heart.9698f8fa.svg";
export { ForwardRef as ReactComponent };